{
  "common": {
    "pcs": "ta"
  },
  "status": {
    "normal": "Normal",
    "warning": "Ogohlantirish",
    "danger": "Xavf",
    "offline": "Ma'lumot yo'q",
    "unknown": "Noma'lum"
  },
  "live": {
    "lastUpdate": "Oxirgi yangilanish: {{time}}",
    "reconnecting": "Aloqa uzildi — qayta ulanmoqda…"
  },
  "elements": {
    "titlePlaceholder": "Sarlavha yozing",
    "subtitlePlaceholder": "Obyekt nomi yozing",
    "imagePlaceholder": "Rasm yuklang",
    "gifPlaceholder": "GIF yuklang",
    "videoPlaceholder": "Video yuklang",
    "sectionsPlaceholder": "Bo'limlar shu yerda ko'rinadi",
    "play": "Ijro etish"
  },
  "languages": {
    "uz-Latn": "O’zb",
    "ru": "Рус",
    "en": "Eng"
  },
  "languageNames": {
    "uz-Latn": "O'zbekcha",
    "ru": "Русский",
    "en": "English"
  },
  "topbar": {
    "language": "Interfeys tili",
    "notifications": "Bildirishnomalar",
    "noNotifications": "Yangi bildirishnomalar yo'q.",
    "themeToLight": "Yorug' mavzuga o'tish",
    "themeToDark": "Qorong'i mavzuga o'tish",
    "userMenu": "Foydalanuvchi menyusi",
    "online": "Onlayn",
    "edit": "Tahrirlash",
    "editDashboard": "Bosh panelni tahrirlash",
    "logout": "Chiqish"
  },
  "viewer": {
    "loading": "Yuklanmoqda…",
    "loadError": "Ma'lumotlarni yuklab bo'lmadi",
    "retry": "Qayta urinish",
    "emptyDashboard": "Bosh panel hali sozlanmagan",
    "emptyDashboardHint": "Administrator fon, vidjetlar va bo'limlarni qo'shgach, ular shu yerda ko'rinadi.",
    "dashboard": "Bosh panel",
    "backToDashboard": "Bosh panelga qaytish",
    "sectionsNav": "Bo'limlar",
    "collapseMenu": "Menyuni yopish",
    "expandMenu": "Menyuni ochish",
    "folders": "Papkalar",
    "statusLegend": "Qurilmalar holati",
    "fullscreen": "To'liq ekran",
    "exitFullscreen": "To'liq ekrandan chiqish",
    "deviceInfo": "Qurilma haqida ma'lumot",
    "edit": "Tahrirlash",
    "sectionNotFound": "Bo'lim topilmadi",
    "emptySection": "Bu bo'limda hali ma'lumot yo'q",
    "emptySectionHint": "Chizma, jadval yoki grafik qo'shilgach, ular shu yerda ko'rinadi."
  },
  "panels": {
    "drawing": "Chizmadagi qurilmalar joylashuvi",
    "table": "Jadval",
    "chart": "Qurilma grafigi"
  },
  "table": {
    "index": "T.r.",
    "device": "Qurilma",
    "measuredAt": "O'lchov vaqti",
    "value": "Qiymati",
    "status": "Holat",
    "empty": "Jadvalda ko'rsatiladigan qurilmalar yo'q",
    "formulaError": "Xato"
  },
  "chart": {
    "noSeries": "Grafik uchun qurilmalar tanlanmagan",
    "waiting": "Ma'lumotlar kutilmoqda…",
    "time": "Vaqt"
  },
  "deviceInfo": {
    "title": "Qurilma haqida ma'lumot",
    "subtitle": "Qurilma haqida ma'lumot · {{tenant}}",
    "readings": "Ko'rsatkichlar",
    "noReadings": "Qurilmaga ko'rsatkichlar bog'lanmagan",
    "media": "Rasm va video",
    "mediaCount": "{{count}} ta",
    "description": "Ta'rif",
    "empty": "Qurilma haqida qo'shimcha ma'lumot kiritilmagan.",
    "close": "Yopish",
    "pdf": "PDF yuklab olish",
    "previous": "Oldingi",
    "next": "Keyingi"
  }
}
